import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var segmentedControlIndicator = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_1kw8mkp4',variantClassNames:{prefersReducedMotion:{reduced:'fx_2d2fb1e5_1kw8mkp5',noPreference:'fx_2d2fb1e5_1kw8mkp6'}},defaultVariants:{prefersReducedMotion:'noPreference'},compoundVariants:[]});
var segmentedControlIndicatorHeight = 'var(--fx_2d2fb1e5_1kw8mkp1)';
var segmentedControlIndicatorTranslateX = 'var(--fx_2d2fb1e5_1kw8mkp2)';
var segmentedControlIndicatorWidth = 'var(--fx_2d2fb1e5_1kw8mkp0)';

export { segmentedControlIndicator, segmentedControlIndicatorHeight, segmentedControlIndicatorTranslateX, segmentedControlIndicatorWidth };
//# sourceMappingURL=indicator.vanilla.mjs.map
